export default __webpack_public_path__ + "media/images/temporary/mud-run-5-6e2184e1e7b4bb42aeee3c2de9f831be.jpg";